export default {

    SET_DPR_OUTPUTS: (state, payload) => state.dprOutputs = payload,
  
  }